export default __webpack_public_path__ + "static/media/building.f689c742.svg";